import React, {PropsWithChildren} from 'react';
import {Typography} from '@mui/material';
import classNames from 'classnames';
import {Component} from 'app/types/common';

interface Props extends PropsWithChildren<Component> {
  title: string;
}

export function PaymentSection({className, title, dataId, children}: Props) {
  return (
    <div data-id={dataId} className={classNames('payment-section', className)}>
      <Typography fontSize={16} fontWeight="bold" mb={1}>
        {title}
      </Typography>

      {children}
    </div>
  );
}
